import React, { useMemo } from "react";
import Markdown from "react-markdown";
import { cn } from "@/shared/utils/shadcn";
import { createMarkdownComponents } from "./_components";
import { CustomTagsData } from "./_components/MarkdownComponents";
import { htmlToMarkdown } from "@/shared/utils/parsers/htmlToMarkdown";

interface MarkdownTextProps {
  text: string;
  className?: string;
  data?: CustomTagsData;
  /**
   * Content created by the previous (Slate) editor is stored as HTML, so
   * summaries and notes need converting to markdown before they render.
   * Turn this off for content that is already markdown: the conversion also
   * turns any HTML in user-supplied text (names, notes) into real markup,
   * whereas react-markdown on its own renders those tags as literal text.
   */
  convertLegacyHtml?: boolean;
}

const MarkdownText: React.FC<MarkdownTextProps> = ({
  text,
  className,
  data,
  convertLegacyHtml = true,
}) => {
  // Memoize markdown components to prevent unnecessary re-renders
  const markdownComponents = useMemo(
    () => createMarkdownComponents(data),
    [data]
  );

  const markdownText = useMemo(
    () => (convertLegacyHtml ? htmlToMarkdown(text) : text),
    [text, convertLegacyHtml]
  );

  return (
    <div
      className={cn(
        "prose prose-gray max-w-none text-md text-gray-700",
        className
      )}
    >
      <Markdown components={markdownComponents}>{markdownText}</Markdown>
    </div>
  );
};

export default MarkdownText;
